import { saveTrendSelections } from "../Dashboard/utils/trendSelectionsStorage";

const TREND_SELECTION_ACTIONS = new Set([
  "trends/setDevicesFilter",
  "trends/removeDeviceFilter",
  "trends/clearFilterList",
]);

const DEBOUNCE_MS = 300;
const pendingTimers = new Map(); // systemId -> setTimeout handle

const flushPendingWrites = (storeApi) => {
  pendingTimers.forEach((timer, systemId) => {
    clearTimeout(timer);
    const trends = storeApi.getState().historical?.[systemId]?.trends;
    saveTrendSelections(systemId, trends?.devicesFilterList);
  });
  pendingTimers.clear();
};

/** Persists trend chart selections to localStorage under "Trends_<systemId>", debounced per system. */
const trendSelectionsPersistMiddleware = (storeApi) => {
  // Ensures the last debounced write isn't lost when the tab closes mid-debounce.
  if (typeof window !== "undefined") {
    window.addEventListener("beforeunload", () => flushPendingWrites(storeApi));
  }

  return (next) => (action) => {
    const result = next(action);
    if (TREND_SELECTION_ACTIONS.has(action.type)) {
      const systemId = action.payload?.systemId;
      if (!systemId) return result;

      clearTimeout(pendingTimers.get(systemId));
      pendingTimers.set(
        systemId,
        setTimeout(() => {
          pendingTimers.delete(systemId);
          const trends = storeApi.getState().historical?.[systemId]?.trends;
          saveTrendSelections(systemId, trends?.devicesFilterList);
        }, DEBOUNCE_MS)
      );
    }
    return result;
  };
};

export default trendSelectionsPersistMiddleware;
